import React, { useRef } from "react";
import SearchBar from "./order-table/order-filters/SearchBar";
import FilterDropdown from "./order-table/order-filters/FilterDropdown";
import ExportButton from "./order-table/order-actions/ExportButton";
import ImportButton from "./order-table/order-actions/ImportButton";
import { FilterOptions } from "../../types/order";
import { StaffMember } from "src/shared/services/interfacev2";

interface OrderControlsProps {
  searchTerm: string;
  setSearchTerm: (val: string) => void;
  filters: FilterOptions;
  setFilters: React.Dispatch<React.SetStateAction<FilterOptions>>;
  appliedFilters: FilterOptions;
  dropdownOpen: boolean;
  setDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
  orders: any[];
  exportLoading: boolean;
  setExportLoading: (val: boolean) => void;
  importLoading: boolean;
  setImportLoading: (val: boolean) => void;
  staffList: StaffMember[];
  getFilterPlaceholder: () => string;
  handleSearch: () => void;
  resetFilters: () => void;
  onImport: () => void;
}

const OrderControls: React.FC<OrderControlsProps> = ({
  searchTerm,
  setSearchTerm,
  filters,
  setFilters,
  appliedFilters,
  dropdownOpen,
  setDropdownOpen,
  orders,
  exportLoading,
  setExportLoading,
  importLoading,
  setImportLoading,
  staffList,
  getFilterPlaceholder,
  handleSearch,
  resetFilters,
  onImport,
}) => {
  const isLoading = exportLoading || importLoading;
  const searchRef = useRef<HTMLDivElement>(null); // 🔹 Ref to get SearchBar width


  return (
    <div className="relative w-full">
      {/* Loading Overlay */}
      {isLoading && (
        <div className="fixed inset-0 bg-white/60 flex items-center justify-center z-[9999]">
          <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
        </div>
      )}

      {/* Main Controls */}
      <div className={`flex flex-col md:flex-row md:items-center justify-between gap-4 ${isLoading ? "opacity-50 pointer-events-none" : ""}`}>
        {/* Title */}
        <div>
          <h2 className="text-xl ml-8 font-semibold text-gray-800">Orders</h2>
        </div>

        {/* Search + Filters */}
        <div className="relative" ref={searchRef}>
          <SearchBar searchTerm={searchTerm} placeholder={getFilterPlaceholder()} onSearchChange={setSearchTerm} onFilterToggle={() => setDropdownOpen(!dropdownOpen)} isFilterOpen={dropdownOpen} />

          {dropdownOpen && (
            <FilterDropdown
              filters={filters}
              staffList={staffList}
              onFilterChange={(key, value) => setFilters((prev) => ({ ...prev, [key]: value }))}
              onApply={handleSearch}
              onReset={resetFilters}
              onClose={() => setDropdownOpen(false)}
              parentRef={searchRef} // 🔹 match width with search bar
            />
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex items-center gap-3">
          <ExportButton orders={orders} filters={{ ...appliedFilters, searchTerm }} onLoading={setExportLoading} />
          <ImportButton onImport={onImport} onLoading={setImportLoading} />
        </div>
      </div>
    </div>
  );
};

export default OrderControls;
